import React, { useState, useEffect } from 'react';
import Header from './Header'; // Import Header component
import Sidebar from './Sidebar'; // Import Sidebar component
import './PatientDetails.css'; // Ensure you create this CSS file for styling
import './Dashboard.css'; // Ensure you create this CSS file for styling
import { faArrowLeft, faChevronLeft, faChevronRight, faCamera, faPrint, faShareAlt, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'; // Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {axiosInstance,axiosAmarlabInstance} from './helper/axiosConfig';
import prescriptionImg from '../assets/img/prescription-dummy.png'; // Import the logo
import { useParams } from 'react-router-dom'; // Import useParams hook
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Import Link and useLocation for navigatio
import { isAdmin, isDoctor } from './helper/authRoles';
import toast, { Toaster } from 'react-hot-toast';

const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};

// Utility function to get the first letter of the patient's name
const getAvatarLetter = (name) => {
  return name ? name.charAt(0).toUpperCase() : '?';
};


function PatientDetails({ match }) {
  const [patientInfo, setPatientInfo] = useState({});
  const [loading, setLoading] = useState(true); // Loading state
  const [avatarBgColor, setAvatarBgColor] = useState(getRandomColor());
  const { id } = useParams();
  const history = useNavigate(); // Hook for navigation
  const [userId, setUserId] = useState(0); // Loading state

  // Sample patient data
    //alert(${id})
  // Sample prescription data
  const prescriptions = [
    {
      id: "#77127",
      date: "21 Aug 2024, 10:15 am",
      symptoms: "Cold, Fever",
      diagnosis: "CBC",
    },
    {
      id: "#57128",
      date: "18 July 2024, 10:15 am",
      symptoms: "Cold, Fever",
      diagnosis: "CBC",
    },
  ];

  useEffect(() => {
      const fetchPatientData = async () => {
        try {
          //const response = await axiosInstance.get(`/api/patient-details/${id}`); // Fetch patient data from API
          const response = await toast.promise(
            axiosInstance.get(`/api/patient-details/${id}`),
            {
              loading: 'Loading patient...',
              success: <b>Patient loaded successfully!</b>,
              error: <b>Failed to loading patient details.</b>,
            }
          );

          const patientData = response.data; // Store patient data
          console.log("The data is = ", patientData);

          if (patientData.prescriptions && Array.isArray(patientData.prescriptions)) {
            // Enrich each prescription with diagnostic data from Amarlab
            const enrichedPrescriptions = await Promise.all(
              patientData.prescriptions.map(async (prescription) => {
                try {
                  const orderResponse = await axiosAmarlabInstance.get(
                    '/order/sneho-order-tree/',
                    {
                      params: {
                        from_sneho: 1,
                        sneho_prescription_id: prescription.id,
                      },
                    }
                  );
                  prescription.diagnostic = orderResponse.data?.results || [];
                } catch (error) {
                  console.error(
                    `Error fetching diagnostic data for prescription ID ${prescription.id}:`,
                    error
                  );
                  prescription.diagnostic = []; // Default to an empty array on error
                }
                return prescription;
              })
            );

            // Update patient data with enriched prescriptions
            patientData.prescriptions = enrichedPrescriptions;
          }
          console.log("the prescription data is ===============", patientData)
          setPatientInfo(patientData); // Bind the enriched patient data
          setLoading(false); // Set loading to false after data is fetched
        } catch (error) {
          console.error("Error fetching patient data:", error);
          setLoading(false); // Ensure loading is set to false on error
        }
      };
      fetchPatientData();

      const userInfo = localStorage.getItem('user-info');
      const parsedUserInfo = userInfo ? JSON.parse(userInfo) : null;
      if(parsedUserInfo && parsedUserInfo.user_id){
        setUserId(parsedUserInfo.user_id)
      }
  }, [id]); // Dependencies include match.params

  const handleDeletePatient = async (patientId) => {
    const r = window.confirm("Are you sure to remove the patient?");
    if(r){
      try {
        await axiosInstance.delete(`/api/patient/${patientId}`);
        // Handle successful deletion, e.g., update the list of appointments, show a success message
        console.log('Patient deleted successfully');
        history('/patient-history'); // Redirect after successful creation        //history('/appoinment-history'); // Redirect after successful creation
      } catch (error) {
        console.error('Error deleting patient:', error);
        // Handle error, e.g., show an error message to the user
      }
    }
  };

  const renderDxTags = (dx) => {
    if (!dx) {
      // If dx is null, undefined, or an empty string, return null or an empty element
      return <span className="tag">No data</span>;
    }
    const tags = dx.split(", ");

    // Only show the first 3 tags, followed by "..." if there are more
    const displayedTags = tags.slice(0, 3).map((tag, index) => (
      <span key={index} className="tag">
        {tag}
      </span>
    ));

    return (
      <>
        {displayedTags}
        {tags.length > 3 && <span className="tag">...</span>}
      </>
    );
  };



  return (
    <div className="dashboard-container">
      <Sidebar /> {/* Sidebar component */}
      <div className="dashboard-main">
        <Header /> {/* Header component */}
        <div className="content-box ">
          <div className="patient-details-container">

            {/* Patient Profile Header */}
            <div className="patient-header">
                <div className="back-icon-wrapper">
                <Link to="/patient-history"> <FontAwesomeIcon icon={faArrowLeft} className="back-icon" /> </Link>
                </div>
                <div className="center-content">
                    <h2 className="profile-name">{patientInfo.name}'s Profile</h2>
                    <div className="profile-picture-wrapper">
                    <div
                        className="profile-picture"
                        style={{
                        backgroundColor: avatarBgColor, // Random background color
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: '#fff',
                        fontSize: '36px',
                        fontWeight: 'bold',
                        }}
                    >
                        {/* First character of the name */}
                          {/* Check for profile picture and render it or fallback to first character of the name */}
                          {patientInfo.profile_pic ? (
                              <img src={patientInfo.profile_pic} alt="Profile" style={{ borderRadius: '50%', width: '100%', height: '100%' }} />
                          ) : (
                              patientInfo.name ? patientInfo.name.charAt(0).toUpperCase() : '?'
                          )}
                        <FontAwesomeIcon icon={faCamera} className="camera-icon" />
                    </div>

                    </div>
                </div>
                <div className="edit-icon-wrapper">
                  {isAdmin() && (
                    <>
                      <Link to={`/update-patient/${id}`} > <FontAwesomeIcon icon={faEdit} className="back-icon" /> </Link>
                      {(!patientInfo.prescriptions || patientInfo.prescriptions.length === 0) && (
                          <a onClick={() => handleDeletePatient(patientInfo.id)} className="trash-icon">
                            <FontAwesomeIcon icon={faTrash} className="trash-icon back-icon" />
                          </a>
                      )}
                    </>
                  )}
                  {isDoctor() && userId === patientInfo.created_by && (
                    <>
                      <Link to={`/update-patient/${id}`} > <FontAwesomeIcon icon={faEdit} className="back-icon" /> </Link>
                    </>
                  )}
                </div>
            </div>


            {/* Patient Information */}
            <div className="patient-info-div">
                <div className="patient-info">
                <div className="info-section">
                    <p><strong>Age:</strong> {patientInfo.age || "N/A"} {patientInfo.age_type}</p>
                    <p><strong>DOB:</strong> {patientInfo.dob ? new Date(patientInfo.dob).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long', // or 'short' for shorter month names
                        day: 'numeric',
                    }) : "N/A"}
                    </p>
                    <p><strong>Gender:</strong> {patientInfo.gender || "N/A"}</p>
                    <p><strong>Marital Status:</strong> {patientInfo.marital_status || "N/A"}</p>
                </div>
                <div className="info-section">
                    <p><strong>Mobile:</strong> {patientInfo.mobile || "N/A"}</p>
                    <p><strong>District:</strong> {patientInfo.address_district || "N/A"}</p>
                    <p><strong>Thana:</strong> {patientInfo.address_thana || "N/A"}</p>
                    <p><strong>Occupation:</strong> {patientInfo.occupation || "N/A"}</p>
                </div>
                </div>
            </div>

            {/* Prescriptions Section */}
            <div className="prescriptions-section">
            <div className="prescriptions-header">
                <h1>Prescriptions ({patientInfo.prescriptions ? patientInfo.prescriptions.length : 0})</h1>
                {isDoctor() && (
                <Link to="/create-prescription"> <button className="create-new-prescription-btn">
                + Create New Prescription
                </button> </Link>
                )}
            </div>
              {/* Prescriptions List */}
              {patientInfo.prescriptions && patientInfo.prescriptions.length > 0 ? (
                    patientInfo.prescriptions.map((prescription, index) => (
                        <div key={index} className="prescription-card">
                        <div className="prescription-image">
                        <Link to={`/prescription-preview/${prescription.id}`}><img src={prescriptionImg} alt="Prescription" /></Link>
                        </div>
                        <div className="prescription-details">

                              <>
                              <p className="prescription-id">#{prescription.id.toString().padStart(6, '0')}</p>
                                {/* Chief Complaint */}
                                {prescription.chief_complaint && (
                                  <p className="prescription-s-d">
                                    <span>Chief Complaint:</span> {prescription.chief_complaint}
                                  </p>
                                )}

                                {/* Doctor *
                                {prescription.doctor && (
                                  <p className="prescription-s-d">
                                    <span>Doctor:</span> {prescription.doctor}
                                  </p>
                                )}
                                */}
                                {/* Patient */}
                                {prescription && prescription.doctor && (
                                  <p className="prescription-s-d">
                                    <span>Doctor:</span>

                                    <div className="avatar-circle" style={{width: "35px", height:"35px",marginRight:"7px", marginLeft: "10px", backgroundColor: !prescription.doctor.profile_pic ? getRandomColor() : 'transparent' }}>
                                      {prescription.doctor.profile_pic ? (
                                        <img
                                              src={`${process.env.REACT_APP_AXIOS_BASE_URL}/media/${prescription.doctor.profile_pic}`} // Concatenating the base URL and profile_pic
                                              alt={prescription.doctor.full_name}  className="avatar-circle"
                                            // Ensure the profile-pic class is styled in your CSS
                                            />

                                      ) : (
                                        <span className="initials" style={{lineHeight: "25px", fontSize: "14px"}}>{getAvatarLetter(prescription.doctor.full_name)}</span>
                                      )}
                                    </div>

                                     {prescription.doctor.full_name}
                                  </p>
                                )}

                                {prescription && (prescription.height > 0 || prescription.weight > 0) && (
                                  <p className="prescription-s-d">
                                    {prescription.height > 0 && <span>Height: </span>}
                                    {prescription.height > 0 && `${prescription.height} Feet, `}
                                    {prescription.weight > 0 && <span>Weight: </span>}
                                    {prescription.weight > 0 && `${prescription.weight} KG`}
                                  </p>
                                )}

                                <p><span>History:</span> {renderDxTags(prescription.relevant_history?.trim() || "")}</p>
                              </>
                            <div className='prescription-btn' style={{ paddingTop: '10px' }}>
                              <button className="btn print-btn">
                              <Link to={`/prescription-preview/${prescription.id}`}><FontAwesomeIcon icon={faPrint} /> Print</Link>
                              </button>
                              <button className="btn share-btn">
                              <Link to={`/prescription-preview/${prescription.id}`}><FontAwesomeIcon icon={faShareAlt} /> Share</Link>
                              </button>
                            </div>
                        </div>
                        <div className="prescription-actions">
                          <p>
                            {prescription.created_at
                              ? `${new Date(prescription.created_at).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'long', // or 'short' for shorter month names
                                  day: 'numeric',
                                })} ${new Date(prescription.created_at).toLocaleTimeString('en-US', {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  second: '2-digit',
                                })}`
                              : "N/A"}
                          </p>

                          {prescription && prescription.diagnostic?.length > 0 && (
                            <>
                              <strong>Diagnostics (Amarlab)</strong>
                              {prescription.diagnostic
                                .flatMap((order) => order.orderreport) // Combine all orderreport arrays
                                .map((report) => (
                                  <div key={report.id}>
                                    {report.tests} (
                                    <a
                                      style={{ color: "#3c84c5", textDecoration: "none" }}
                                      href={report.report}
                                      target="_blank"
                                      rel="noreferrer noopener"
                                    >
                                      {report.name}
                                    </a>
                                    )
                                  </div>
                                ))}
                            </>
                          )}


                          {prescription && prescription.reports?.length > 0 && (
                            <>
                              <strong>Diagnostics (Sneho)</strong>
                              {prescription.reports
                                .map((report) => (
                                  <div key={report.id}>

                                    <a title={report.note}
                                      style={{ color: "#3c84c5", textDecoration: "none" }}
                                      href={`${process.env.REACT_APP_AXIOS_BASE_URL}/media/${report.report}`}
                                      target="_blank"
                                      rel="noreferrer noopener"
                                    >
                                      {report.name}
                                    </a>

                                  </div>
                                ))}
                            </>
                          )}
                        </div>
                        </div>
                    ))
                ) : (
                <p>No prescriptions found.</p>
                )}

            </div>

          </div>
        </div>
        <div className="footer-content">
            {process.env.REACT_APP_COPYRIGHT_TEXT || "© 2025, Powered by AmarLab"}
        </div>
      </div>
    </div>
  );
}

export default PatientDetails;
